
import * as vClickOutside from "v-click-outside";
/* eslint-disable */
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    listName: {
      type: String,
      default: "options",
    },
    value: {
      type: [String, Number],
      default: null,
    },

    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropdownOpen: false,
      activeTooltip: null,
      activeActivityID: null,
      activities: [],
      options: [
        {
          name: "name",
          label: "Naziv opcije",
          type: "text",
        },
        {
          name: "id",
          label: "id",
          type: "text",
        },
      ],
    };
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  watch: {
    value() {
      this.dropdownOpen = false;
    },
  },
  mounted() {
    this.getActivities();
  },
  methods: {
    async getActivities() {
      var commonsApi;
      if (this.$i18n.locale === "hr") {
        commonsApi = "https://api.gaussbox.com/api/v1/commons?language=hrv";
      } else commonsApi = "https://api.gaussbox.com/api/v1/commons";

      try {
        const data = await this.$axios.get(commonsApi);
        if (
          data &&
          data.data &&
          data.data.data &&
          data.data.data.industryTypes
        ) {
          this.activities = data.data.data.industryTypes;
        }
      } catch (e) {
        console.log(e);
      }
    },
    filterFunction() {
      const input = document.getElementById("search");
      const filter = input.value.toUpperCase();
      const div = document.getElementById("mySearchDropdown");
      const items = div.getElementsByTagName("a");
      for (let i = 0; i < items.length; i++) {
        const txtValue = items[i].textContent || items[i].innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          items[i].style.display = "";
        } else {
          items[i].style.display = "none";
        }
      }
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    setActivityID(activityID) {
      if (!activityID) return;
      this.activeActivityID = activityID;
    },
  },
};
